import React, { useEffect, useRef, useState, useMemo, lazy, Suspense } from 'react';
import './css/styles.css';
import { Row, Col } from 'react-bootstrap';
import { TransitionGroup, CSSTransition } from 'react-transition-group';
import { Link } from 'react-router-dom';
import { FaHome } from 'react-icons/fa';
const Step1 = lazy(() => import('./steps/step1'));
const Step2 = lazy(() => import('./steps/step2'));
const Step3 = lazy(() => import('./steps/step3'));
const Footer = lazy(() => import('../footer/Footer'));
const texts = [
  'Congela el precio de los repuestos y ahorra hasta el 38% en mantenimientos preventivos',
  'Uso de repuestos 100% originales',
  'Reduce el riesgo de pérdida de garantía por falta de mantenimientos',
  'Maximiza el valor comercial de tu Hyundai',
  'Beneficio transferible a un segundo propietario',
  '10% de descuento en repuestos de mantenimiento correctivo y accesorios'
];

const ICONS = {
  IconoPaso1: '/assets/step1.svg',
  IconoPaso1Active: '/assets/step1Active.svg',
  IconoPaso2: '/assets/step2.svg',
  IconoPaso2Active: '/assets/step2Active.svg',
  IconoPaso4: '/assets/step4.svg',
  IconoPaso4Active: '/assets/step4Active.svg',
  LogoHyundai: '/assets/hyundai-logo-white.webp',
  Pony: '/assets/pony8.webp',
  PonyAlert: '/assets/pony8.webp',
  RuedaAzul: '/assets/rueda.gif'
};

const MantenimientosPrepagados = () => {
  const [modeloVehiculo, setModeloVehiculo] = useState(null);
  const [modeloVehiculoYear, setModeloVehiculoYear] = useState(null);
  const [activeTab, setActiveTab] = useState(1);
  const [seleccionados, setSeleccionados] = useState(new Set())
  const [ponyDialog, setPonyDialog] = useState('');
  const [dialogColor, setDialogColor] = useState('pony-dialog');
  const [isPonyWriting, setPonyWriting] = useState(true);
  const [ponyClass, setPonyClass] = useState('chatbot-image');
  const [ponyMessageIndex, setPonyMessageIndex] = useState(0);
  const [ponyImage, setPonyImage] = useState(ICONS.Pony);
  const [modeloAgrupador, setModeloAgrupador] = useState(null);
  const [mantenimiento, setMantenimiento] = useState(null);
  const [placa, setPlaca] = useState(null);
  const [imagenCarroModelo, setImagenCarroModelo] = useState('');
  const [codigoModeloYear, setCodigoModeloYear] = useState("");
  const [yearP, setYearP] = useState("");
  const [vin, setVin] = useState("");
  const [activeKey, setActiveKey] = useState("");
  const [periodo, setPeriodo] = useState("");
  const [setLockMessage] = useState(false);
  const [isSubmitPressed, setIsSubmitPressed] = useState(false);
  const [congratsShown, setCongratsShown] = useState(false);
  const [isPonyVisible, setPonyVisible] = useState(true);
  const [ponyLowered, setPonyLowered] = useState(false);
  const [ponyLowering, setPonyLowering] = useState(false);
  const [applyAnimation, setApplyAnimation] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [currentText, setCurrentText] = useState(texts[0]);
  const [ponyIntro, setPonyIntro] = useState(
    <div id="lcp-placeholder" className='mt-3 ml-2' style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
      <h3 className="hfontr">Hola soy Pony</h3>
      <h3 className='hfontl'>Ingresa el número de placa o selecciona el modelo de vehiculo</h3>
    </div>
  );

  const footerRef = useRef();
  const [showFooter, setShowFooter] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        setShowFooter(true);
      }
    });
    if (footerRef.current) observer.observe(footerRef.current);
    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    const el = document.getElementById('lcp-placeholder');
    if (el) el.remove();
  }, []);


  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((currentIndex + 1) % texts.length);
      setCurrentText(texts[currentIndex]);
    }, 5000);
    return () => clearInterval(interval);
  }, [currentIndex, currentText]);

  useEffect(() => {
    const timer = setTimeout(() => {
      setApplyAnimation(true);
    }, 1000);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [activeTab]);

  const updateImagenCarroModelo = (url) => {
    setImagenCarroModelo(url);
  };

  const updateCodigoModeloYear = (data) => {
    setCodigoModeloYear(data);
  }

  const updatePeriodo = (data) => {
    setPeriodo(data);
  }

  const updateYearP = (data) => {
    setYearP(data);
  }

  const updateVin = (data) => {
    setVin(data);
  }

  const updateActivekey = (data) => {
    setActiveKey(data);
  }

  const ponyIntroRef = useRef(ponyIntro);

  useMemo(() => {
    setPonyIntro(ponyIntro);
    ponyIntroRef.current = ponyIntro;
  }, [ponyIntro]);

  useEffect(() => {
    const timer = setTimeout(() => {
      setPonyDialog(ponyIntroRef.current);
      setPonyWriting(false);
      setPonyClass('chatbot-image ');
    }, 2000);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    const css = '.support-menu { display: none; }',
      head = document.head || document.getElementsByTagName('head')[0],
      style = document.createElement('style');
    head.appendChild(style);
    style.type = 'text/css';
    if (style.styleSheet) {
      style.styleSheet.cssText = css;
    } else {
      style.appendChild(document.createTextNode(css));
    }
    return () => {
      head.removeChild(style);
    }
  }, []);

  const handleStepClick = (step) => {
    if (step < activeTab) {
      setActiveTab(step);
      if (step === 1) {
        setModeloVehiculo(null);
        setModeloVehiculoYear(null);
        setSeleccionados(new Set());
        setPonyDialog('');
        setDialogColor('pony-dialog');
        setModeloAgrupador(null);
        setMantenimiento(null);
        setPlaca(null);
        setImagenCarroModelo('');
        setCodigoModeloYear("");
        setYearP("");
        setActiveKey("");
        setPeriodo("");
        setIsSubmitPressed(false);
        setCongratsShown(false);
        setPonyWriting(true);
        setTimeout(() => {
          setPonyDialog(ponyIntro);
          setPonyWriting(false);
        }, 3000);
      } else if (step === 2) {
        setPonyWriting(true);
        setPonyDialog('');
        setTimeout(() => {
          setPonyDialog('Aplica tus beneficios a partir del 4to mantenimiento seleccionado');
          setPonyWriting(false);
        }, 3000);
      }
    } else {
      //  avanzando a los siguientes pasos
      if ((step === 2 || step === 3) && !modeloVehiculo) {
        setPonyDialog('¡Hey! Debes completar la información de Vehículo primero.');
        setDialogColor('pony-dialog-red');
        setPonyImage(ICONS.PonyAlert);
        setTimeout(() => {
          setPonyDialog(ponyIntro);
          setDialogColor('pony-dialog');
        }, 4000);
      } else if (step === 3 && seleccionados.size === 0) {
        setPonyDialog('¡Hey! Debes completar la selección de mantenimientos primero.');
        setDialogColor('pony-dialog-red');
        setPonyImage(ICONS.PonyAlert);
        setTimeout(() => {
          setPonyDialog('Aplica tus beneficios a partir del 4to mantenimiento seleccionado');
          setDialogColor('pony-dialog');
        }, 4000);
      } else {
        setActiveTab(step);
      }
    }
  };

  const Step = ({ label, stepNumber, activeStep, onClick, icon, iconActive }) => (
    <div
      className={`step ${activeStep >= stepNumber ? 'active' : ''}`}
      onClick={onClick}
      style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: '15px', cursor: 'pointer', fontFamily: 'HyundaiSansHead-Regular' }}
    >
      <img
        src={activeStep >= stepNumber ? iconActive : icon}
        alt={label}
        style={{ width: '80px', height: '80px' }}
      />
      <div style={{ fontFamily: activeStep >= stepNumber ? 'HyundaiSansHead-Regular' : 'HyundaiSansHead-Light' }}>{label}</div>
    </div>
  );

  const PonyDialog = ({ children, escribiendo, className }) => (
    isPonyVisible && !ponyLowered && (
      <button
        style={{ position: 'absolute', top: 9, right: 8, background: 'transparent', border: 'none' }}
        onClick={() => {
          setPonyVisible(false);
          setPonyLowering(true);
          setPonyClass('chatbot-image chatbot-image-hidden no-animation');
        }}
      >
        <div className={ponyLowered ? `${dialogColor} pony-dialog-closed` : dialogColor} style={{ textAlign: 'left', marginLeft: "15px" }}>
          {children}
          {escribiendo && <img src={ICONS.RuedaAzul} style={{ width: '32px', height: '32px' }} alt="Escribiendo..." />}
        </div>
      </button>
    )
  );

  useEffect(() => {
    if (ponyLowering) {
      const timer = setTimeout(() => {
        setPonyLowered(true);
        setPonyLowering(false);
      }, 500);
      return () => clearTimeout(timer);
    }
    /*  eslint-disable-next-line react-hooks/exhaustive-deps */
  }, []);

  const mensajes = [
    "Despliega para conocer tus beneficios!",
    "Despliega para conocer los detalles de tus mantenimientos",
    "Completa la información para tu cotización",
  ];

  const intervalId = useRef(null);

  useEffect(() => {
    if (activeTab === 3 && !isSubmitPressed && !congratsShown) {
      if (intervalId.current !== null) {
        clearInterval(intervalId.current);
      }
      intervalId.current = setInterval(() => {
        setPonyWriting(false);
        setTimeout(() => {
          setPonyDialog(mensajes[ponyMessageIndex]);
          setPonyMessageIndex((ponyMessageIndex + 1) % mensajes.length);
          if (ponyMessageIndex === mensajes.length - 1) {
            setCongratsShown(false);
            clearInterval(intervalId.current);
          }
        }, 1500);
      }, 5000);
    }
  }, [activeTab, ponyMessageIndex, congratsShown]);

  useEffect(() => {
    if (isSubmitPressed && intervalId.current) {
      clearInterval(intervalId.current);
    }
  }, [isSubmitPressed]);

  const prefersReducedMotion = useMemo(
    () => window.matchMedia('(prefers-reduced-motion: reduce)').matches,
    []
  );


  const myDiv = React.useRef(null);

  return (
    <div className="mantenimientos-prepagados" ref={myDiv}>
      <div className='menu'>
        <div className='logo-container'>
          <img
            src={ICONS.LogoHyundai}
            className="logo"
            alt="Logo Hyundai"
            loading="lazy"
            width="120"
            height="40"
          />

        </div>
        <div className="middle-container">
          <div className='benefit-container'>
            <h1 className='h1'>BENEFICIOS:</h1>
          </div>
          <div className="text-container">
            <TransitionGroup>
              <CSSTransition
                key={currentIndex}
                timeout={prefersReducedMotion ? 0 : 800}
                classNames={prefersReducedMotion ? "" : "fade"}
              >
                <h2 className="h2">{texts[currentIndex]}</h2>
              </CSSTransition>
            </TransitionGroup>
          </div>
        </div>
        <div className="home-icon-container">
          <Link to="/" aria-label="Enlace a la página de inicio">
            <button className="home-button" aria-label="Volver al inicio">
              <FaHome size={24} color="white" />
            </button>
          </Link>
        </div>
      </div>
      {/* Pasos */}
      <Row className="steps">
        <Col xs={12} md={4}>
          <Step
            label="1. Información Vehicular"
            stepNumber={1}
            activeStep={activeTab}
            onClick={() => handleStepClick(1)}
            icon={ICONS.IconoPaso1}
            iconActive={ICONS.IconoPaso1Active}
          />
        </Col>
        <Col xs={12} md={4} className="step-divider">
          <div className="step-divider-symbol">&gt;</div>
          <Step
            stepNumber={2}
            activeStep={activeTab}
            onClick={() => handleStepClick(2)}
            icon={ICONS.IconoPaso2}
            iconActive={ICONS.IconoPaso2Active}
            label="2. Mantenimientos"
          />
        </Col>
        <Col xs={12} md={4} className="step-divider">
          <div className="step-divider-symbol">&gt;</div>
          <Step
            label="3. Confirmar"
            stepNumber={3}
            activeStep={activeTab}
            onClick={() => handleStepClick(3)}
            icon={ICONS.IconoPaso4}
            iconActive={ICONS.IconoPaso4Active}
          />
        </Col>
      </Row>
      <hr className="full-width-line" />
      {/* Contenido de los pasos */}
      <div className="content mt-3">
        <Suspense fallback={<div>Cargando...</div>}>
          {activeTab === 1 && (
            <Step1
              onContinuar={() => {
                setActiveTab(2);
                setPonyWriting(true);
                setPonyDialog('');
                setTimeout(() => {
                  setPonyDialog("Aplica tus beneficios a partir del 4to mantenimiento seleccionado");
                  setPonyWriting(false);
                }, 2000);
                if (window.innerWidth <= 768) {
                  myDiv.current.scrollTo(0, 320);
                }
              }}
              updateModeloVehiculo={setModeloVehiculo}
              updateModeloVehiculoYear={setModeloVehiculoYear}
              setImagenCarroModelo={setImagenCarroModelo}
              updateModeloAgrupador={setModeloAgrupador}
              updateMantenimiento={setMantenimiento}
              updateImagenCarroModelo={updateImagenCarroModelo}
              updatePlaca={setPlaca}
              updateCodigoModeloYear={updateCodigoModeloYear}
              updatePeriodo={updatePeriodo}
              updateYearP={updateYearP}
              updateVin={updateVin}
              updateActivekey={updateActivekey}
            />
          )}
          {activeTab === 2 && (
            <Step2
              modeloVehiculo={modeloVehiculo}
              modeloVehiculoYear={modeloVehiculoYear}
              modeloAgrupador={modeloAgrupador}
              mantenimiento={mantenimiento}
              imagenCarroModelo={imagenCarroModelo}
              periodo={periodo}
              codigoModeloYear={codigoModeloYear}
              handleStepClick={handleStepClick}
              yearP={yearP}
              vin={vin}
              activeKey={activeKey}
              onContinuar={(seleccionados) => {
                setSeleccionados(seleccionados);
                setActiveTab(3);
                setPonyDialog('');
                setPonyWriting(true);
                setPonyMessageIndex(0);
                if (window.innerWidth <= 768) {
                  myDiv.current.scrollTo(0, 350);
                }
              }}
            />
          )}
          {activeTab === 3 && (
            <Step3
              modeloVehiculo={modeloVehiculo}
              modeloVehiculoYear={modeloVehiculoYear}
              codigoModeloYear={codigoModeloYear}
              periodo={periodo}
              modeloAgrupador={modeloAgrupador}
              mantenimientosSeleccionados={seleccionados}
              mantenimiento={mantenimiento}
              imagenCarroModelo={imagenCarroModelo}
              updatePonyDialog={setPonyDialog}
              updateLockMessage={setLockMessage}
              handleStepClick={handleStepClick}
              placa={placa}
              onContinuar={() => {
                setActiveTab(4);
                setPonyWriting(true);
                setIsSubmitPressed(true);
                setTimeout(() => {
                  setPonyDialog("Haz click para confirmar tu pedido!");
                  setPonyWriting(false);
                }, 9000);
              }}
            />
          )}
        </Suspense>
        <div className={activeTab === 2 || activeTab === 3 ? "blue-stripe1" : "blue-stripe"}></div>
        {/*
        <div className={activeTab === 2 || activeTab === 3 ? "blue-stripe1" : "blue-stripe"}>
          <PonyDialog className={dialogColor} escribiendo={isPonyWriting}>
            {ponyDialog}
          </PonyDialog>
          <img
            src={ponyImage}
            alt="Chatbot"
            className={`${ponyClass} ${ponyLowering ? 'chatbot-image-lowered' : ''} ${applyAnimation ? 'pony' : ''}`}
            style={{ cursor: 'pointer' }}
            onClick={() => {
              setPonyLowered(false);
              setPonyVisible(true);
              setPonyLowering(false);
              setPonyClass('chatbot-image  pony1');
            }}
          />
        </div>
        */}
        
        <div ref={footerRef}>
          {showFooter && (
            <Suspense fallback={<div>Cargando footer...</div>}>
              <Footer />
            </Suspense>
          )}
        </div>

      </div>
    </div>
  );
};

export default MantenimientosPrepagados;